import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import DateField from "../DateField";
import "./DateTimeField.css";

var DateTimeField =
/** @class */
function (_super) {
  tslib_1.__extends(DateTimeField, _super);

  function DateTimeField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.fixFormat = function (format) {
      return format.replace('LT', 'h:mm a');
    };

    return _this;
  }

  DateTimeField.prototype.render = function () {
    var _a = this.props,
        blockName = _a.blockName,
        className = _a.className,
        format = _a.format,
        displayFormat = _a.displayFormat,
        timeFormat = _a.timeFormat,
        other = tslib_1.__rest(_a, ["blockName", "className", "format", "displayFormat", "timeFormat"]);

    var finalClassName = cx(blockName, className);
    var formats = {
      format: format && this.fixFormat(format),
      displayFormat: displayFormat && this.fixFormat(displayFormat),
      timeFormat: timeFormat && this.fixFormat(timeFormat)
    };
    return React.createElement(DateField, tslib_1.__assign({
      className: finalClassName,
      showTimeSelect: true
    }, formats, other));
  };

  DateTimeField.propTypes = {
    blockName: PropTypes.string,
    className: PropTypes.string,
    format: PropTypes.string,
    timeFormat: PropTypes.string,
    timeIntervals: PropTypes.number,
    timeCaption: PropTypes.string,
    displayFormat: PropTypes.string
  };
  DateTimeField.defaultProps = {
    blockName: 'nx-datetimefield',
    format: 'MM/DD/YYYY h:mm a',
    timeIntervals: 15,
    timeCaption: 'Time',
    displayFormat: 'MM/DD/YYYY h:mm a'
  };
  return DateTimeField;
}(Component);

export default DateTimeField;

try {
  // @ts-ignore
  DateTimeField.__docgenInfo = {
    "description": "",
    "displayName": "DateTimeField",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}